import React from 'react';
import { Col, Row, Panel, FormGroup, FormControl, Button } from 'react-bootstrap';
import DateTime from 'react-datetime';

const IncentivesSearch = props => (
  <Panel className="submission-filter">
    <Row>
      <Col md={3}>
        <FormGroup>
          Incentive name
          <FormControl
            onChange={props.onNameChange}
            placeholder="Incentive name keyword"
            value={props.nameValue}
          />
        </FormGroup>
      </Col>
      <Col md={3}>
        <FormGroup>
          End date from
          <DateTime
            timeFormat={false}
            dateFormat="DD/MM/YYYY"
            value={props.dateFromValue}
            onChange={props.onDateFromChange}
            closeOnSelect
            inputProps={{
              placeholder: 'Date from'
            }}
          />
        </FormGroup>
      </Col>
      <Col md={3}>
        <FormGroup>
          End date to
          <DateTime
            timeFormat={false}
            dateFormat="DD/MM/YYYY"
            value={props.dateToValue}
            onChange={props.onDateToChange}
            closeOnSelect
            inputProps={{
              placeholder: 'Date to'
            }}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col md={6} className="actions" style={{marginTop: '20px'}}>
        <Button
          className="red-ghost-btn"
          onClick={props.onClear}
        >Clear search/filters
        </Button>
        <Button
          className="red-ghost-btn"
          onClick={props.onSearch}
        >Search
        </Button>
      </Col>
    </Row>
  </Panel>
);

export default IncentivesSearch;



// WEBPACK FOOTER //
// ./src/components/admin/incentives/incentives-search.jsx